export const valueMappingSalesInsights = [
    {
        label: 'Lu',
        value: false,
        originalLabel: 'monday',
    },
    {
        label: 'Ma',
        value: false,
        originalLabel: 'tuesday',
    },
    {
        label: 'Mi',
        value: false,
        originalLabel: 'wednesday',
    },
    {
        label: 'Ju',
        value: false,
        originalLabel: 'thursday',
    },
    {
        label: 'Vi',
        value: false,
        originalLabel: 'friday',
    },
    {
        label: 'Sa',
        value: true,
        originalLabel: 'saturday',
    },
    {
        label: 'Do',
        value: false,
        originalLabel: 'sunday',
    },
];
